import { StorageOfUniqueDialogs } from '@qality/common-service';

import AddAttachmentDialog from './AddAttachmentDialog';
import AddToTestCycleDialogService from './AddToTestCycleDialogService';
import DeleteTestStepDialog from './DeleteTestStepDialog';
import TestCaseExecutionDialog from './TestCaseExecutionDialog';
import TestCaseFullScreenDialog from './TestCaseFullScreenDialog';

export default {
  init(): void {
    StorageOfUniqueDialogs.add('AddAttachmentDialog', AddAttachmentDialog);
    StorageOfUniqueDialogs.add(
      'AddToTestCycleDialogService',
      AddToTestCycleDialogService
    );
    StorageOfUniqueDialogs.add('DeleteTestStepDialog', DeleteTestStepDialog);
    StorageOfUniqueDialogs.add(
      'TestCaseExecutionDialog',
      TestCaseExecutionDialog
    );
    StorageOfUniqueDialogs.add(
      'TestCaseFullScreenDialog',
      TestCaseFullScreenDialog
    );
  },
};
